<template>
  <div>
    <v-card>
      <v-toolbar color="primary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('internal') }}</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form">
        <v-card-text v-if="foodTruck.partner">
           <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('termsAndConditions')"
                        v-model="foodTruck.termsAndConditions" />
                         <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('cooperationInformation')"
                        v-model="foodTruck.cooperationInformation" />
                         <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('wholesaler')"
                        v-model="foodTruck.wholesaler" />
        </v-card-text>
        <v-card-text>
          <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('contactPerson')"
                        v-model="foodTruck.contactPerson" />
          <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('dimensions')"
                        v-model="foodTruck.dimensions" />
          <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('powerRequirements')"
                        v-model="foodTruck.powerRequirements" />
          <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('posSystem')"
                        v-model="foodTruck.posSystem" />
          <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('topSellingDish')"
                        v-model="foodTruck.topSellingDish" />
          <v-text-field class="mb-6"
                        filled
                        hide-details="auto"
                        v-bind:label="$t('outputPerHour')"
                        v-model="foodTruck.outputPerHour" />
          <v-textarea class="mb-6"
                      filled
                      hide-details="auto"
                      v-bind:label="$t('notes')"
                      v-model="foodTruck.notes" />
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    computed: {
           rules() {
        return {
          required: v => !!v || this.$t('global.pleaseFillOutThisField')
        }
      },
      ...mapGetters({
      })
    },
    name: 'FoodTruckInternalDetailsCard',
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    props: {
      foodTruck: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "internal": "Intern",
      "contactPerson": "Ansprechpartner",
      "dimensions": "Maße",
      "powerRequirements": "Strombedarf",
      "posSystem": "Kassensystem",
      "topSellingDish": "Topseller Gericht",
      "outputPerHour": "Output pro Stunde",
      "notes": "Notizen",
      "termsAndConditions": "Konditionen",
      "cooperationInformation": "Kooperationsinformationen",
      "wholesaler": "Großhändler"
    },
    "en": {
      "internal": "Internal",
      "contactPerson": "Contact Person",
      "dimensions": "Dimensions",
      "powerRequirements": "Power Requirements",
      "posSystem": "POS System",
      "topSellingDish": "Top Selling Dish",
      "outputPerHour": "Output Per Hour",
      "notes": "Notes",
      "termsAndConditions": "Terms and Conditions",
      "cooperationInformation": "Cooperation Information",
      "wholesaler": "Wholesaler"
    }
  }
</i18n>